import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { OverlayView } from '@react-google-maps/api';
import { HotelMarkerContent } from 'components/Map/HotelMarker/HotelMarkerContent';
import { getHotelFromRtkQuery } from 'middleware/analytics/selectors';
import { getHotelTopOffer } from 'modules/sapiSearch/selectors';
import { Text } from '@daedalus/atlas/Text';
import { getIsPrivateDeal } from '@daedalus/core/src/auth/modules/selectors';
import { calculateDistance } from '@daedalus/core/src/utils/geolocation/calculateDistance';
import { MarkerDistance } from './MarkerDistance';
import { useMapHotelPrice } from './useMapHotelPrice';
import type { ContentHotel } from '@findhotel/sapi';
interface Props {
  hotelId: string;
  currentLocation: ContentHotel['_geoloc'];
  /* Anchor for the streetview = AP hotel */
  isAnchor: boolean;
  isSelected: boolean;
  onClick: (hotel: ContentHotel) => void;
}
const _exp = /*#__PURE__*/() => Text;
const HotelName = /*#__PURE__*/styled(_exp())({
  name: "HotelName",
  class: "h1wzm48o",
  propsAsIs: true
});
const MarkerPosition = /*#__PURE__*/styled('div')({
  name: "MarkerPosition",
  class: "m1yojvdp",
  propsAsIs: false
});
export const StreetviewMarker = ({
  hotelId,
  currentLocation,
  isAnchor,
  isSelected,
  onClick
}: Props) => {
  const hotel = useSelector(state => getHotelFromRtkQuery(state, hotelId));
  const center = {
    lat: hotel._geoloc.lat,
    lng: hotel._geoloc.lon
  };
  const price = useMapHotelPrice({
    hotelId
  });
  const topOffer = useSelector(state => getHotelTopOffer(state, hotelId));
  const isPrivateDeal = useSelector(getIsPrivateDeal(topOffer));
  const distance = calculateDistance(hotel._geoloc, currentLocation);

  // Note: the main map has some extra logic around "anchor" here but we are in AP context for a particular hotel
  const hasPrice = price && price > 0;
  const showMarker = hotel && hasPrice;
  if (!showMarker) return null;
  return <OverlayView position={center} mapPaneName="overlayMouseTarget">
      <MarkerPosition>
        <HotelMarkerContent id={hotelId} price={price} isSelected={isSelected} isAnchor={isAnchor} isPrivateDeal={isPrivateDeal} hotelNameSlot={isAnchor && <HotelName variant="labelXS">{hotel.hotelName}</HotelName>} distanceSlot={!isAnchor && <MarkerDistance isSelected={isSelected} distance={distance} />} onClick={() => onClick(hotel)} />
      </MarkerPosition>
    </OverlayView>;
};

require("./StreetviewMarker.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./StreetviewMarker.tsx");